// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import en from '@shopify/polaris/locales/en.json';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useUpdate } from 'ahooks';
import { ConfigProvider } from 'antd';
import Cookies from 'js-cookie';
import { useEffect, useLayoutEffect } from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { Constants } from '../constants';
import { urlHelper } from '../helper/url-helper';
import { NoLoginRoutes } from '../no-login-page';
import '../style/app.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      cacheTime: 0,
    },
  },
});

const noLoginUrl = ['/joinTeam', '/login', '/price-plan', '/mobile/business-dashboard', '/mobile/share', '/mobile/phone-login', '/mobile/berification-code'];

export function App() {
  const update = useUpdate();
  useLayoutEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const token = search.get('token');
    if (token) {
      Cookies.set(Constants.AccessTokenKey, token, { expires: 7 });
      // 给smartlook 打标志
      Cookies.set(Constants.MarkIsDevelopUser, '1', { expires: 14 });
    }
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const rootElement: any = document.getElementById('root');
    if (isMobile) {
      console.log(rootElement);

      rootElement.style.setProperty('min-width', 'auto', 'important'); // 取消min-width样式
      import('lib-flexible')
        .then(() => {
          console.log('lib-flexible loaded successfully');
          // 在这里可以进一步处理 lib-flexible 加载后的逻辑
        })
        .catch((error) => {
          console.error('Failed to load lib-flexible', error);
        });
    }
  }, []);

  useEffect(() => {
    // 短信跳转接口也是免登录
    const isNoLoginUrl = noLoginUrl.includes(window.location.pathname) || window.location.pathname.includes('/s/');
    // 如果不是免登录，不做处理
    if (!isNoLoginUrl) return;
    const isRedirect = window.location.pathname.includes('/s/');
    const Loading = document.getElementById('loadingDiv');
    if (Loading && !isRedirect) {
      Loading.classList.add('animate__animated', 'animate__fadeOut');
      Loading.style.display = 'none';
    }
    update();
  }, []);

  return (
    <HistoryRouter history={urlHelper.history as any}>
      {/* <Provider config={config}> */}
      <QueryClientProvider client={queryClient}>
        <ConfigProvider form={{ colon: false }}>
          <AppProvider i18n={en}>
            <NoLoginRoutes />
          </AppProvider>
        </ConfigProvider>
      </QueryClientProvider>
      {/* </Provider> */}
    </HistoryRouter>
  );
}

export default App;
